import { Box, Typography } from "@mui/material";
import { StewartDialog } from "controls/global/dialogs/stewart-dialog/StewartDialog";
import styled from "styled-components";
import {
  borderRadius,
  colors,
  fontSize,
  fontWeight,
  gaps,
  iconSize,
  margin,
  padding,
} from "theme/defaultStyle";

export const StyledDialog = styled(StewartDialog)({
  "& > .MuiDialog-container > .MuiDialog-paper": {
    maxHeight: "calc(95vh)",
    maxWidth: "760px",
    minWidth: "760px",
    display: "flex",
    flexDirection: "column",
    padding: `${padding.xlarge21_5} ${padding.xlarge22} ${padding.xlarge22} ${padding.xlarge22}`,
    overflow: "hidden",
  },
});

export const StyledDialogTitle = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: gaps.large1,
  marginBottom: margin.small1,
  "& .MuiTypography-root": {
    fontSize: fontSize.xlarge2,
    fontWeight: fontWeight.bold2,
  },
});

export const StyledDescriptionTypography = styled(Typography)({
  color: colors.grey22,
  fontSize: fontSize.small,
  marginBottom: margin.large,
});

export const IconContainer = styled("div")({
  background: colors.blue19,
  borderRadius: borderRadius.large,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "56px",
  height: "56px",
  "& .MuiSvgIcon-root": {
    color: colors.blue15,
    fontSize: iconSize.medium2,
  },
});

export const CloseIconContainer = styled("div")({
  background: colors.grey10,
  borderRadius: borderRadius.xlarge1,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  marginLeft: "auto",
  marginBottom: "auto",
  width: "32px",
  height: "32px",
  padding: "4px",
  "& .MuiSvgIcon-root": {
    color: colors.blue01,
    width: "24px",
    height: "24px",
  },
  "& .iconButton": {
    padding: padding.zero,
    backgroundColor: colors.grey10,
  },
});

export const StyledDialogContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: gaps.large1,
  flex: 1,
  overflowY: "auto",
  overflowX: "hidden",
});

export const FieldsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: gaps.large1,
  rowGap: gaps.large1,
});

export const FullWidthCell = styled(Box)({
  gridColumn: "1 / -1",
});

export const FieldCell = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: gaps.xsmall1,
  minWidth: 0,
  "& .errorMessage": { display: "none" },
});

export const RequiredFieldCell = styled(FieldCell)({
  "& label::after, & .MuiOutlinedInput-notchedOutline legend > span::after": {
    content: '" *"',
    color: colors.red01,
  },
});

export const DialogFooter = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: gaps.small1,
  margin: `${margin.large} 0`,
  paddingTop: padding.large1,
  borderTop: `1px solid ${colors.grey09}`,
});
